import React, { useMemo } from 'react';

const ConfirmDeleteModal = ({ isOpen, onClose, onConfirm, item }) => {
    
    const message = useMemo(() => {
        if (item?.type === 'bulk') {
            return `Tem certeza que deseja apagar os ${item.count} itens selecionados?`;
        }
        
        const typeName = item?.type === 'product' ? 'o produto' : 
                         item?.type === 'customer' ? 'o cliente' : 
                         'a transação';

        return <>Tem certeza que deseja apagar {typeName} <strong>{item?.name}</strong>?</>;
    }, [item]);

    if (!isOpen) {
        return null;
    }

    return (
        <div className="modal-overlay">
            <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 w-full max-w-md m-4 sm:m-8">
                <h2 className="text-xl font-bold text-gray-800 mb-4">Confirmar Exclusão</h2>
                <p className="text-gray-600 mb-6">
                    {message} Esta ação não pode ser desfeita.
                </p>
                <div className="flex flex-col-reverse sm:flex-row justify-end gap-4">
                    <button 
                        type="button" 
                        onClick={onClose} 
                        className="py-2 px-6 bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 w-full sm:w-auto"
                    >
                        Cancelar
                    </button>
                    <button 
                        onClick={onConfirm} 
                        className="bg-red-600 text-white py-2 px-6 font-semibold rounded-lg hover:bg-red-700 w-full sm:w-auto"
                    >
                        Apagar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDeleteModal;
